/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LogEvent } from '../models/LogEvent';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LogEventService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all log events in the DB.
     * @param pageNumber
     * @param pageSize
     * @returns LogEvent OK
     * @throws ApiError
     */
    public getAllLogEvents(
        pageNumber?: number,
        pageSize: number = 50,
    ): CancelablePromise<Array<LogEvent>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/logging/LogEvent/GetAllLogEvents',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
